import { ComponentsOverrides, Theme } from '@mui/material';

export const DialogStyles: ComponentsOverrides<Theme>['MuiDialog'] =
  {
    container: {
      display: 'flex',
    },
    paperFullScreen: {
      '& form': {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      },
    },
  }

  export const DialogContentStyles: ComponentsOverrides<Theme>['MuiDialogContent'] =
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
      padding: '2rem 1.5rem',
      flexGrow: 1,
    }
  }

  export const DialogActionsStyles: ComponentsOverrides<Theme>['MuiDialogActions'] =
  {
    root: {
      padding: '1rem 1.5rem',
      justifyContent: 'space-between'
    }
  }